import React from 'react'
import { Button, FormInstance, Modal } from 'antd';
import { TFunction } from 'i18next';
import classes from './TermsModal.module.scss';
import PDFViewer from 'components/Webviewer/Viewer/PDFViewer';
import { BuildNames, Languages, privacyAgreement } from 'interfaces/IBuildLanguage';
import cn from 'classnames';
import { getTheme } from 'helpers/getTheme';

// @ts-ignore
const buildName: BuildNames = window.REACT_APP_BUILD_NAME !== 'REPLACE_REACT_APP_BUILD_NAME' ? window.REACT_APP_BUILD_NAME : process.env.REACT_APP_BUILD_NAME || 'tazadeal';

type PrivacyModalProps = {
  isPrivacyModalOpen?: boolean;
  setIsPrivacyModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  t: TFunction;
  form: FormInstance<any>;
};

export default function PrivacyModal(
  {
    isPrivacyModalOpen,
    setIsPrivacyModalOpen,
    t,
    form,
  }: PrivacyModalProps
) {
  const [isAvailableAccept, setIsAvailableAccept] = React.useState<boolean>(true);
  const isAlreadyAccept = form.getFieldValue(['is_accepted_privacy']);

  const footerWithAcceptButton = (
    <Button
      disabled={!isAvailableAccept}
      type='primary'
      onClick={() => {
        form.setFieldsValue({ is_accepted_privacy: true });
        form.validateFields(['is_accepted_privacy']);
        setIsPrivacyModalOpen(false);
      }}
    >
      {t('Confirm.acceptPolicy')}
    </Button>
  )

  return (
    <Modal
      className={cn(classes.modalLicense, getTheme())}
      width={'90%'}
      onCancel={() => setIsPrivacyModalOpen(false)}
      title={t('PersonalInfo.privacyTitle')}
      open={isPrivacyModalOpen}
      centered={true}
      footer={isAlreadyAccept ? null : footerWithAcceptButton}
    >
      <div style={{height: '85vh'}}>
        <PDFViewer
          url={privacyAgreement[buildName][Languages.Ru]} // [i18n.language as Languages] // useTranslation()
          isModal={false}
          // setIsAvailableAccept={setIsAvailableAccept}
        />
      </div>
    </Modal>
  )
};
